import React, { useState, useEffect } from 'react';
import { Image, Card, Row, Col, Input, Spin, Modal } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import './ImageGallery.css';

const { Search } = Input;

const ImageGallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  // 模拟图片数据 - 实际项目中替换为真实API
  const mockImages = [
    {
      id: 1,
      url: 'https://picsum.photos/300/200?random=1',
      title: '美丽风景 1',
      description: '这是一张美丽的风景图片'
    },
    {
      id: 2,
      url: 'https://picsum.photos/300/250?random=2',
      title: '城市夜景',
      description: '繁华的城市夜景'
    },
    {
      id: 3,
      url: 'https://picsum.photos/300/180?random=3',
      title: '自然风光',
      description: '大自然的美丽风光'
    },
    {
      id: 4,
      url: 'https://picsum.photos/300/220?random=4',
      title: '建筑艺术',
      description: '现代建筑艺术'
    },
    {
      id: 5,
      url: 'https://picsum.photos/300/200?random=5',
      title: '海边日落',
      description: '美丽的海边日落'
    },
    {
      id: 6,
      url: 'https://picsum.photos/300/240?random=6',
      title: '山川河流',
      description: '壮丽的山川河流'
    },
    {
      id: 7,
      url: 'https://picsum.photos/300/190?random=7',
      title: '花卉植物',
      description: '美丽的花卉植物'
    },
    {
      id: 8,
      url: 'https://picsum.photos/300/210?random=8',
      title: '动物世界',
      description: '可爱的动物们'
    },
    {
      id: 9,
      url: 'https://picsum.photos/300/230?random=9',
      title: '科技未来',
      description: '科技感十足的图片'
    },
    {
      id: 10,
      url: 'https://picsum.photos/300/200?random=10',
      title: '美食诱惑',
      description: '诱人的美食图片'
    },
    {
      id: 11,
      url: 'https://picsum.photos/300/180?random=11',
      title: '旅行记忆',
      description: '美好的旅行回忆'
    },
    {
      id: 12,
      url: 'https://picsum.photos/300/220?random=12',
      title: '艺术创作',
      description: '精美的艺术作品'
    }
  ];

  useEffect(() => {
    loadImages();
  }, []);

  const loadImages = () => {
    setLoading(true);
    // 模拟API调用延迟
    setTimeout(() => {
      setImages(mockImages);
      setLoading(false);
    }, 1000);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setLoading(true);
    
    // 模拟搜索过滤
    setTimeout(() => {
      const filteredImages = mockImages.filter(img => 
        img.title.toLowerCase().includes(value.toLowerCase()) ||
        img.description.toLowerCase().includes(value.toLowerCase())
      );
      setImages(filteredImages);
      setLoading(false);
    }, 500);
  };

  const handlePreview = (image) => {
    setPreviewImage(image.url);
    setPreviewTitle(image.title);
    setPreviewVisible(true);
  };

  const handleCancel = () => {
    setPreviewVisible(false);
  };

  return (
    <div className="image-gallery">
      {/* 搜索栏 */}
      <div className="search-container">
        <Search
          placeholder="搜索图片..."
          allowClear
          enterButton={<SearchOutlined />}
          size="large"
          onSearch={handleSearch}
          style={{ maxWidth: 600, margin: '0 auto', display: 'block' }}
        />
      </div>

      {/* 加载状态 */}
      {loading && (
        <div className="loading-container">
          <Spin size="large" />
        </div>
      )}

      {/* 图片网格 */}
      <div className="images-container">
        <Row gutter={[16, 16]}>
          {images.map((image) => (
            <Col 
              key={image.id} 
              xs={12} 
              sm={8} 
              md={6} 
              lg={4} 
              xl={3}
            >
              <Card
                hoverable
                className="image-card"
                cover={
                  <div className="image-wrapper">
                    <Image
                      alt={image.title}
                      src={image.url}
                      preview={false}
                      onClick={() => handlePreview(image)}
                      className="gallery-image"
                    />
                  </div>
                }
                onClick={() => handlePreview(image)}
              >
                <Card.Meta 
                  title={image.title} 
                  description={image.description} 
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* 图片预览模态框 */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width="80%"
        centered
        className="preview-modal"
      >
        <div className="preview-container">
          <Image
            alt={previewTitle}
            src={previewImage}
            style={{ width: '100%' }}
          />
        </div>
      </Modal>

      {/* 无结果提示 */}
      {!loading && images.length === 0 && (
        <div className="no-results">
          <p>没有找到相关图片</p>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
